import React from 'react';
import { ImageUpload as CommonImageUpload } from '@blueprintnyc/bpnyc-common-admin';
import { imgCustomReq } from 'utils';

const ImageUpload = props => {
	const { endpoint } = props;

	if (!endpoint) {
		console.error('ImageUpload must have prop endpoint, which is the signed url endpoint');
		return null;
	}

	const onUploadSuccess = imgCustomReq(endpoint);

	return <CommonImageUpload {...props} onUploadSuccess={onUploadSuccess} />;
};

export default ImageUpload;
